<mat-form-field>
  <input
    *ngIf="!isLongText"
    [formControl]="email"
    [pattern]="this.regex"
    type="email"
    matInput=""
    [attr.inputmode]="inputMode"
    [attr.autocomplete]="autocomplete"
    placeholder="{{ 'Email address' | translate }}"
    (change)="change()"
    [required]="!question.elective"
  />

  <mat-error i18n="@@Checkemailinformed">{{
    "Check email informed" | translate
  }}</mat-error>
</mat-form-field>

<span class="email-suggestion" *ngIf="domainSuggestion">
  {{ 'EmailDomainSuggestion' | translate: { domain: domainSuggestion } }}
</span>
<span class="email-suggestion" *ngIf="domainUnrecognized">
  {{ 'EmailDomainUnrecognized' | translate }}
</span>
